import { NADevice } from '../NADevice.model';
import operations from '~/helpers/device-operations';
import apiService from '~/services/api.service';
import { NotificationsModule } from '~common-store/modules/notifications';
import { SearchModule } from '~/store/modules/search';
import { Const } from '~/constants/Const.constant';

export class NAModule extends NADevice {
    hasOperationReset = true;
    hasOperationDissociate = true;
    hasOperationImportData = false;

    bridge?: string;
    configured?: boolean;
    mfg_id?: number;
    rf_levels: { [key: string]: number } = {
        full: Const.NARadioRssiTreshold.RADIO_THRESHOLD_3,
        high: Const.NARadioRssiTreshold.RADIO_THRESHOLD_2,
        medium: Const.NARadioRssiTreshold.RADIO_THRESHOLD_1,
        low: Const.NARadioRssiTreshold.RADIO_THRESHOLD_0,
    };

    get deviceOperations() {
        const deviceOperations = super.deviceOperations;
        if (this.hasOperationImportData) {
            deviceOperations.push(operations.importData({
                callback: this.importData as () => Promise<any>,
                params: { device_id: this.bridge || '', type: this.type, module_id: this.id },
            }));
        }
        if (this.hasOperationDissociate) {
            deviceOperations.push(
                operations.dissociate({ callback: this.dissociate, disabled: this.isDissociateDisabled }),
            );
        }
        return deviceOperations;
    }

    get isDissociateDisabled() {
        return { value: !this.bridge, reason: 'Module not associated to a gateway' };
    }

    get column(): string {
        return this.isWired ? 'left' : 'right';
    }

    get outdatedLastSeen() {
        return this.last_seen ? Date.now() / 1000 - this.last_seen > (this.MAX_TIME_BEFORE_UNKNOWN + this.MAINLOOP_OFFSET) : true;
    }

    dissociate = async () => {
        const deviceId = this.bridge;
        if (!deviceId) {
            NotificationsModule.pushNotification({
                type: 'error',
                title: 'error',
                text: 'Module is not associated to a gateway',
            });
            return;
        }
        try {
            await this.handleOperation({
                callback: () => apiService.admindissociatemodule({ device_id: deviceId, module_id: this.id }),
                confirmText: 'You are about to completely dissociate this module, do you want to continue ?',
            });
            // re-search module after dissociation is complete
            SearchModule.search({ searchText: this.id });
        } catch (error) {
            return;
        }
    };

    reset = async () => {
        await super.reset({ device_id: this.bridge || '', module_id: this.id });
    };

    getRfIcon(status?: number) {
        for (const threshold in this.rf_levels) {
            if (status && status < this.rf_levels[threshold]) {
                return `signal_${threshold}`;
            }
        }
        if (!status) {
            return 'signal_unknown';
        }
        return 'signal_low';
    }
}
